var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 11H16.2918C16.7575 11 17.2169 11.1084 17.6334 11.3167L18.2186 11.6093C18.7289 11.8645 19.1559 12.2599 19.4495 12.7491L22 17",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22L14.2486 20.942C13.4383 20.6304 12.7513 20.0636 12.2914 19.3272L9.24268 14.4452C8.84854 13.814 8.94205 12.9944 9.46822 12.4682V12.4682C9.77848 12.1579 10.2026 11.9889 10.6412 12.0006C11.0798 12.0123 11.4943 12.2038 11.7876 12.5302L14.0068 15H16",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13.8795V4.83333C13 3.82081 12.1792 3 11.1667 3H3.83333C2.82081 3 2 3.82081 2 4.83333V17.0556C2 18.0681 2.82081 18.8889 3.83333 18.8889H11.7778",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08577 12.3587C5.30635 11.5773 5.30712 10.3123 6.08749 9.53197C6.86786 8.75159 8.13286 8.75082 8.91419 9.53023",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeal);
export default __webpack_public_path__ + "static/media/deal.b75beb4831e891dedb7233a3714ed52c.svg";
export { ForwardRef as ReactComponent };